<template>
  <div class="card-shadow">
    <img class="w-full" src="@/assets/images/login_logo.png" alt="Login Logo">
    <div class="px-6 py-8">
      <h1 class="text-3xl font-light mt-2 mb-6">
        {{ title }}
      </h1>
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    title: {
      type: String,
      'default': () => (''),
    },
  },
})
</script>

<style scoped>
.card-shadow {
@apply rounded overflow-hidden bg-white;
box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
}
</style>
